<template>
    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path id="Path_226" data-name="Path 226" d="M0,0H24V24H0Z" fill="none"/>
        <path id="Path_227" data-name="Path 227" d="M5,13.18v2.81a2.011,2.011,0,0,0,1.04,1.76l5,2.73a1.986,1.986,0,0,0,1.92,0l5-2.73A2.011,2.011,0,0,0,19,15.99V13.18l-6.04,3.3a1.986,1.986,0,0,1-1.92,0Zm6.04-9.66L2.61,8.12a1.007,1.007,0,0,0,0,1.76l8.43,4.6a1.986,1.986,0,0,0,1.92,0L21,10.09V16a1,1,0,0,0,2,0V9.59a1.006,1.006,0,0,0-.52-.88L12.96,3.52a2.04,2.04,0,0,0-1.92,0Z" fill="currentColor" />
    </svg>
</template>
